export default __webpack_public_path__ + "static/menopauzal-4af7e80a2eb5f2423240cac8dad3eafe.jpg";